module.exports = __webpack_public_path__ + "static/media/visibility-button.ab9f8cd2.svg";